import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

declare var TagCanvas: any;
@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
})
export class SkillsComponent implements OnInit {
  constructor(private titleService: Title) {}

  title = 'Skills - Rahil Hastu';

  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    let title = <HTMLElement[]>(<any>document.querySelectorAll('.title span'));
    let infoForMouse = document.querySelector('.infoForMouse');
    let infoForZoom = document.querySelector('.infoForZoom');
    setTimeout(() => {
      infoForMouse.classList.add('fadeBar');
    }, 5000);

    setTimeout(() => {
      infoForZoom.classList.add('fadeBar');
    }, 6000);

    try {
      TagCanvas.Start('myCanvas', 'tags', {
        textColour: '#e7e7e7',
        outlineColour: 'transparent',
        reverse: true,
        depth: 0.8,
        maxSpeed: 0.05,
        minSpeed: 0.02,
        imageScale: 0.08,
        clickToFront: 1000,
        initial: [0.1, 0.1],
      });
    } catch (e) {
      // something went wrong, hide the canvas container
      document.getElementById('myCanvasContainer').style.display = 'none';
    }

    setTimeout(() => {
      let delay = 0;
      title.forEach((spanEle) => {
        spanEle.style.animation = `comeout 1s ease ${delay}s forwards`;
        delay += 0.05;
      });
    }, 1000);

    title.forEach((spanTag) => {
      spanTag.addEventListener('mouseover', () => {
        spanTag.style.opacity = '1';
        spanTag.style.animation = '';
        spanTag.classList.toggle('bounce');
      });
    });
  }
}
